import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import './LinkButton.css'

const LinkButton = ({ children, style, to }) => {
  return (
    <a className='linkButton' href={to} target='_blank' style={style}>
      <span>{children}</span>
      <FontAwesomeIcon icon={faCaretRight} className='linkButton__icon'/>
    </a>
  )
}

export default LinkButton;